import { createElement } from 'react';
import {
  SearchResults,
  SearchResultItem,
  SearchResultIcon,
  SearchResultLabel,
  SearchResultCategory,
} from '../TopNavigation/style';
import type { NavigationItem } from '@components/navigation/config';

interface SearchItem extends NavigationItem {
  categoryLabel: string;
}

interface SearchResultsListProps {
  results: SearchItem[];
  onSelect: (route: string) => void;
}

export function SearchResultsList({ results, onSelect }: SearchResultsListProps) {
  if (results.length === 0) {
    return (
      <SearchResults>
        <SearchResultItem type="button" style={{ cursor: 'default', opacity: 0.6 }}>
          <SearchResultLabel>Nenhum resultado encontrado</SearchResultLabel>
        </SearchResultItem>
      </SearchResults>
    );
  }

  return (
    <SearchResults>
      {results.map((result, index) => (
        <SearchResultItem
          key={result.key}
          type="button"
          data-search-result
          onClick={() => { onSelect(result.route); }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onSelect(result.route);
            }
            if (event.key === 'ArrowDown') {
              event.preventDefault();
              const next = document.querySelectorAll('[data-search-result]')[index + 1] as HTMLElement;
              next.focus();
            }
            if (event.key === 'ArrowUp') {
              event.preventDefault();
              if (index === 0) {
                const input = document.querySelector('[data-search-input]') as HTMLInputElement;
                input.focus();
              } else {
                const previous = document.querySelectorAll('[data-search-result]')[index - 1] as HTMLElement;
                previous.focus();
              }
            }
          }}
          tabIndex={0}
        >
          <SearchResultIcon>{createElement(result.icon)}</SearchResultIcon>
          <div style={{ flex: 1, minWidth: 0 }}>
            <SearchResultLabel>{result.label}</SearchResultLabel>
            <SearchResultCategory>{result.categoryLabel}</SearchResultCategory>
          </div>
        </SearchResultItem>
      ))}
    </SearchResults>
  );
}
